export default "__VITE_ASSET___be0DYxX__"